/** Value for reduction-target graph toggle / `scopeTwoMethod` query (hyphenated). */
export type ReductionScopeTwoDataType = 'market-based' | 'location-based'

/**
 * Maps `organisation.defaultMarketBased` to reduction UI / `getReductionTargetsGraphData` values.
 */
export function reductionScopeTwoDataTypeFromDefaultMarketBased(
  defaultMarketBased: boolean | undefined,
): ReductionScopeTwoDataType {
  return defaultMarketBased === true ? 'market-based' : 'location-based'
}

/**
 * Maps `organisation.defaultMarketBased` to analytics `getBreakdownTotal` `scopeTwoMethod` query.
 */
export function analyticsScopeTwoMethodFromDefaultMarketBased(
  defaultMarketBased: boolean | undefined,
): 'market' | 'location' {
  return defaultMarketBased === true ? 'market' : 'location'
}

export type AnalyticsEmissionTypeToggle = 'marketBased' | 'locationBased'

export function analyticsEmissionTypeToggleFromDefaultMarketBased(
  defaultMarketBased: boolean | undefined,
): AnalyticsEmissionTypeToggle {
  return defaultMarketBased === true ? 'marketBased' : 'locationBased'
}
